<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">VCを評価する上で、AUMが適正な指標ではない理由</h1>
                <span class="meta"> Posted in December 2021 </span>

                <p class="author-info ">Mark Bivens is a Silicon Valley native and former entrepreneur, having started three companies before becoming a VC. He is the Managing Partner of Shizen Capital (formerly known as Tachi.ai Ventures) in Japan. You can read more on his blog at <a href="http://markbivens.com">http://rude.vc</a> or follow him on Twitter <a href="https://twitter.com/markbivens">@markbivens</a>.</p>

                <figure>
                  <img class="img-fluid" src="img/blog/card/aumwrongmetric.png" alt="">
                </figure>
                
                <p>ベンチャーキャピタルの人たちがプライベートエクイティの人たちに対して言いたがる言葉に、「プライベートエクイティの人たちは AUM で自分のエゴの大きさを自慢するが、ベンチャーキャピタルの人たちは本当に重要なのは IRR であることを知っている」というものがある。</p>

                <p>さて、この3文字の言葉を定義してみよう。まず、エゴという言葉は、性別を問わないように、ここでは婉曲的に使っている（実際には、このような自慢をするのは男性が多いが……）。AUM は Assets Under Management（＝ジェネラルパートナーチームが運用するファンドの総資金量）を意味する。IRR とは、内部収益率（ファンドの投資家に分配されるキャッシュリターンを年率換算したもの）のこと。</p>

                <p>アセットマネージャーが AUM を気にするのは、それが収益の保証に直結するからである。クローズドエンド型の投資ファンドは、一般的に「2:20 モデル」を採用している。これは、年間管理料が2％で、ファンドが生み出したキャピタルゲインのうち20％を分配するというものだ（別名キャリード・インタレスト）。年間管理料は、AUM の直接的な関数であり、毎年 AUM 総額の2%となる。契約上は、ファンドの存続期間（通常は10年間）にわたって設定される。一方、キャリード・インタレストは、ファンドのパフォーマンスに比例して発生するもので、ファンドから発生するキャピタルゲインの20％に相当する。</p>

                <p>したがって、AUM が大きいということは、ファンドの存続期間中、多額の収益が保証されることに直結する。AUM が10億米ドルのファンドマネージャーは、おそらく年間約2,000万米ドルの経常収入を得ているだろう。一方、1,000万米ドル規模のマイクロ VC ファンドでは、管理手数料を通じた経常収益は年間20万米ドルに過ぎない。</p>


                <h2 class="section-heading">ズレが生じるリスク</h2>
                
                <p>管理手数料はファンドの運営をカバーするためのものであるため、過度に高い管理手数料は、マネージング・パートナーの高額な給料、豪華なオフィス、豪華なパーティーにつながる。たとえファンドの業績が低迷していても、2桁台の年間収益が数年間にわたって保証されていれば、かなり快適な生活を送ることができる。これでは、どこかにズレが生じてしまうのではないだろうか。</p>

                <p>一方、小規模な VC ファンドにはそのような余裕は無い。小さな VC ファンドのマネージャーは、管理手数料だけでは豊かになれない。彼らはパフォーマンスを発揮しなければならない。自分が運用しているファンドから大きなキャピタルゲインを得て初めて、彼らはキャリード・インタレストの仕組みを使って自分のために富を得ることができるのだ。IRR は各ファンドの財務パフォーマンスを表している。</p>

                <p>財務的リターンを重視するプライベートエクイティや VC ファンドの LP 投資家にとって、IRR は AUM ではなく、財務的リターンを反映する指標だ。だから、ファンドマネージャーが AUM を自慢するときには、IRR を尋ねるのが適切な反論になると思う。</p>

                <p>正直に言うと、私も以前は AUM を自慢していた。AUM を10億米ドル近く運用していたファンドの元 GP として、カンファレンスではよくこの数字を引き合いに出して自己紹介をしていた。しかし、時間が経つにつれ、IRR がファンドマネージャーとしての私の真の KPI であることを学んだ。IRR は、自分の仕事の出来不出来を示す指標だ。私が最もパフォーマンスの高いファンドは、ファンドサイズが小さく、つまり、AUM が小さいファンドであることは、数学的には異常なことではない。</p>

                <p>実際、IRR よりも AUM を重視する傾向は、エコシステムの段階を示すものでもある。ある地域のベンチャー市場がまだ始まったばかりの頃は、トラックレコードが限られているため、最も近い指標は AUM となる。しかし、ファンドマネージャーが最初の時代を過ぎると、「では、あなたの IRRは?」という質問になってくる。</p>

              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>
